export default __webpack_public_path__ + "static/media/support_team.d00a7275.png";